import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DIVIDEND DECLARATION RELATED APIs
// ==============================================

// 1. Insert Dividend Declaration (POST)
export const insertDividendDeclaration = async (params) => {
    try {
        
        // Validate required parameters
        if (!params.financialYear) {
            throw new Error('Financial Year is required');
        }
        if (!params.declarationDate) {
            throw new Error('Declaration Date is required');
        }
        if (!params.netProfitAfterTax) {
            throw new Error('Net Profit After Tax is required');
        }
        if (!params.dividendPercentage) {
            throw new Error('Dividend Percentage is required');
        }
        if (!params.remarks) {
            throw new Error('Remarks are required');
        }
        if (!params.createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.roleId) {
            throw new Error('RoleId is required');
        }
        
        // ✅ FIXED: Use PascalCase to match C# model properties
        const payload = {
            FinancialYear: params.financialYear.toString().trim(),           // Capital F
            DeclarationDate: params.declarationDate.toString().trim(),       // Capital D
            NetProfitAfterTax: parseFloat(params.netProfitAfterTax),        // Capital N, P, A, T
            DividendPercentage: parseFloat(params.dividendPercentage),       // Capital D, P
            Remarks: params.remarks.toString().trim(),                       // Capital R
            Createdby: params.createdby.toString().trim(),                   // Capital C
            RoleId: parseInt(params.roleId)                                  // Capital R, I
        };
        
        
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/InsertDividendDeclaration`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
// 2. Approve/Verify/Reject Dividend Declaration (PUT)
export const approveDividendDeclaration = async (params) => {
    try {
        
        // Validate required parameters
        if (!params.transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }
        if (!params.roleid) {
            throw new Error('RoleId is required');
        }
        if (!params.action) {
            throw new Error('Action is required');
        }
        if (!params.createdby) {
            throw new Error('Createdby is required');
        }
        
        // ✅ FIXED: Use PascalCase to match C# model
        const payload = {
            TransactionRefno: parseInt(params.transactionRefno),  // Capital T, R
            Roleid: parseInt(params.roleid),                      // Capital R
            Action: params.action.toString().trim(),              // Capital A
            Note: params.note?.toString().trim() || '',           // Capital N
            Createdby: params.createdby.toString().trim()         // Capital C
        };
        
        
        const response = await axios.put(
            `${API_BASE_URL}/Accounts/ApproveDividendDeclaration`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Verify Dividend Declaration Inbox (GET)
export const getVerifyDividendDeclaration = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerifyDividendDeclaration/${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Dividend Declaration by Reference Number (GET)
export const getDividendDeclarationByRefno = async (params) => {
    try {
        const { transactionRefno } = params;
         // DEBUG
        
        // Validate required parameters
        if (!transactionRefno) {
            throw new Error('Transaction Reference Number is required');
        }
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDividendDeclarationByRefno/${transactionRefno}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Dividend Declaration List with Filters (GET)
export const getDividendDeclarationList = async (params = {}) => {
    try {
         // DEBUG
        
        // Build query parameters (all are optional)
        const queryParams = new URLSearchParams();
        
        if (params.status) {
            queryParams.append('status', params.status.toString().trim());
        }
        if (params.financialYear) {
            queryParams.append('financialYear', params.financialYear.toString().trim());
        }
        if (params.fromDate) {
            queryParams.append('fromDate', params.fromDate.toString().trim());
        }
        if (params.toDate) {
            queryParams.append('toDate', params.toDate.toString().trim());
        }
        
        const url = queryParams.toString() 
            ? `${API_BASE_URL}/Accounts/GetDividendDeclarationList?${queryParams}` 
            : `${API_BASE_URL}/Accounts/GetDividendDeclarationList`;
        
         // DEBUG
        
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};